<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4 v-if="!mobile">Compteurs</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="table-overflow">
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Saisissez votre recherche"
                            ></b-form-input>

                            <b-table    :fields="fields"
                                        :items="items"
                                        :filter="filter"
                                        :no-sort-reset="true"
                                        @filtered="onFiltered"
                                        class='BTable' sticky-header striped no-border-collapse>
                                <template #cell(Outil_associe)="data">
                                    <div v-if="data.item.Outil_associe!='-'" class="btn-group " role="group">
                                        <p class="btn btn-sm btn-outline-light active" v-on:click="unassign_sensor(data.item.sensor)">{{ data.item.Outil_associe}} <br>{{data.item.Outil_associe_depuis}} </p>
                                            <button type="button" class="btn btn-danger btn-sm" v-on:click="unassign_sensor(data.item.sensor)"><i class="ti-close"></i></button>        
                                    </div>
                                   
                                  <div v-else>
                                      <button type="button" class="btn btn-sm btn-primary m-auto" v-on:click="assign_modal(data.item.sensor)">Affecter</button>
                                  </div>
                                </template>  

                                <template #cell(Calibration_compteur)="data">
                                    <button class="btn btn-icon btn-rounded mrg-top-5" 
                                    v-bind:class="[(data.item.Calibration_compteur.display_unit_id !=+1 ) ? 'btn-primary' : 'btn-flat']" @click="open_calibrate_modal(data.item.Calibration_compteur)">
                                        <i class="ti-settings"></i>
                                    </button>
                                </template>
 
                                <template #cell(status)="data">
                                    <button class="btn btn-icon mrg-top-5" v-bind:class="[(data.item.status & 0x01 ) ? 'btn-warning' : 'btn-flat']" @click="change_alarm(data.item.sensor)">
                                                <i class="ti-bell"></i>
                                    </button>
                                </template>

                                <template #cell(Derniere_mise_a_jour)="data">
                                    <span :style="data.item.LastUpdateWarning? 'color : red' : '' ">
                                    {{data.item.Derniere_mise_a_jour}}
                                    </span>
                                </template>

                                <template #cell(Niveau_Batterie)="data">
                                    <mdicon v-if="data.item.Niveau_Batterie>4.1" name="battery" />
                                    <mdicon v-if="data.item.Niveau_Batterie<=4.1 && data.item.Niveau_Batterie>3.92" name="battery-80" />
                                    <mdicon v-if="data.item.Niveau_Batterie<=3.92 && data.item.Niveau_Batterie>3.87" name="battery-60" />
                                    <mdicon v-if="data.item.Niveau_Batterie<=3.87 && data.item.Niveau_Batterie>3.75" name="battery-30" />
                                    <mdicon v-if="data.item.Niveau_Batterie<=3.75 && data.item.Niveau_Batterie>3.7" name="battery-20" />
                                    <mdicon v-if="data.item.Niveau_Batterie<=3.7" name="battery-alert-variant-outline" style="color:red"/>
                                    <!--<span :style="data.item.BatteryWarning ? 'color : red' : '' ">
                                        {{data.item.Niveau_Batterie}} V
                                    </span>-->
                                </template>

                                <template #cell(extraction)="data">
                                    <button class="btn btn-icon btn-rounded btn-info" @click="open_extraction_sensor(data.item.sensor)">
                                        <i class="ti-export"></i>
                                    </button>
                                </template>

                                <template #cell(Derniere_position)="data">
                                   <button class="btn btn-icon mrg-top-5" v-bind:class="[(data.item.sensor.geolocation_type=='None') ? 'lightBlueColor btn-default btn-rounded ' : 'btn-rounded lightBlueColor']" @click="map_modal_open(data.item.sensor)" :disabled='data.item.sensor.geolocation_type=="None"'>
                                        <i class="ti-map-alt"></i>
                                    </button>
                                </template>

                                <template #cell(graph)="data">
                                    <button class="btn btn-icon mrg-top-5 btn-rounded lightBlueColor" @click="graph_sensor_modal_open(data.item.sensor)">
                                        <font-awesome-icon icon="fa-solid fa-chart-column"/>
                                    </button>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!-- ######################################################################################### -->
        <b-modal ref="assign_modal" hide-footer centered title="Affecter votre compteur">
            <div class="d-block text-center">
                <form @submit.stop.prevent="assign_submit">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Compteur : {{selected_sensor.name}} </label><br>
                                <label>Sélectionnez le nouvel outil à affecter à ce compteur</label>
                                <select class="custom-select" v-model="selected_system" required>
                                    <option value="null" selected>Choisissez un outil</option>
                                    
                                    <option v-for="system in free_systems" v-bind:value="system" v-bind:key="system">
                                          {{system.name}} ({{system.code}})
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div> 
                    <div v-if="((selected_system!=null) && (selected_system.sensor_type != selected_sensor.type))">
                        <label class="text-center" style="color:red">Attention, le type de mesure demandée par la calibration de l'outil est différente du type de compteur. Cela peu conduire à des incohérences d'affichages.</label>
                    </div> 
                    <div class="text-right mrg-top-5">
                        <button type="button" v-on:click="assign_cancel" class="btn btn-default">Annuler</button>
                        <button type="submit" 
                                class="btn" 
                                v-bind:class="[((selected_system!=null) && (selected_system.sensor_type != selected_sensor.type)) ? 'btn-outline-danger' : 'btn-primary']" 
                                v-bind:disabled='(selected_system == "")'>Affecter</button>
                    </div>
                </form>
            </div>
        </b-modal>

<!-- ######################################################################################### -->        
        <b-modal ref="calibration_popup" hide-footer centered title="Parametrez votre outil" >
            <v-calibration 
                :system="mirror_system"
                @calibration-done = "close_calibrate_modal"
            >
            </v-calibration>
        </b-modal>

        <b-modal ref="map_popup" hide-footer centered title="Dernière position du compteur"  v-bind:size="(this.mobile ? '' : 'xl')">
            <v-map 
                :location_info="selected_sensor"
                @map-done = "close_map_modal"
            >
            </v-map>
        </b-modal>

        <b-modal ref="extraction_popup_sensor" hide-footer centered title="Extraction" size="xl">
            <!-- to change the b-modal size size="xl" or size="lg" or size="sm" -->
            <div  class="card border-0 align-items-center" v-for="struct in structure" v-bind:key="struct.id">
            <v-extraction-sensor
                :sensor="selected_sensor"
                :start_date="struct.cloture_exercice"
                :subscriptionOK="_props.subscriptionOK"
                @extraction-done = "close_extraction_sensor">
                Custom2
            </v-extraction-sensor>
            </div>
        </b-modal>

        
        <b-modal ref="graph_popup_sensor" hide-footer centered v-bind:title="'Graphes : '+selected_sensor.name" size="xl">
            <!-- to change the b-modal size size="xl" or size="lg" or size="sm" -->
            <div  class="card border-0 align-items-center" v-for="struct in structure" v-bind:key="struct.id">
                <v-graph
                    :sensor="selected_sensor"
                    :subscriptionOK="_props.subscriptionOK"
                    @graph-done = "close_graph_sensor_modal">
                    Custom
                </v-graph>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
    import Calibrate from "../Systems/Calibrate";
    import Extraction from "../../components/Extraction/Extraction.vue";
    import mMap from "../../components/Map/Map";
    import Graph from "@/components/Graph/Graph3.vue";

    export default {
        name: "Index",
        components:{
            'v-calibration': Calibrate,
            'v-extraction-sensor' : Extraction,
            'v-map': mMap,
            'v-graph' : Graph
        },
        props :{
            subscriptionOK : Boolean,
            required: true
        },
        data () {
            return {
                selected_sensor : false,
                selected_system: null,
                free_systems : [1],
                mirror_system :{
                    name: "",
                    code: "",
                    id: 1,
                    display_unit_id: 1,
                    display_unit:{
                        factor: 1,
                        tyre_size : 0,
                        working_width :0 
                    },
                },
                window: {
                    width: 0,
                    height: 0
                },
                mobile: false,
                tdClass : "text-center align-middle",
                thClass : "text-center",
                
                rows: 1,
                filter: null,
            }
        },
        computed: {
            ...mapGetters({ 
                structure : 'structure/structure',
                sensors: 'sensors/sensors',
                systems: 'systems/systems',
            }),

            fields(){
                var fields=[];
                var key="Outil_associe"; 
                var label ="Outil associé";
                if(!this.subscriptionOK){
                    key="Calibration_compteur";
                    label="Calibration compteur";
                }
                if(this.mobile){
                    fields=[
                        {key :'Nom_du_compteur', sortable: true,thClass: this.thClass,tdClass:  this.tdClass } ,
                        {key :key, label:label,sortable: true,thClass: this.thClass,tdClass:this.tdClass } ,
                        {key :'Compteur_absolu', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Time_use', label :'Temps d\'utilisation', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Niveau_Batterie', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Derniere_mise_a_jour', label :'Dernière mise à jour', sortKey:'SDate_on_update', sortable: true,thClass: this.thClass,tdClass:this.tdClass  } ,
                        {key :'Type_compteur', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'status', label : 'Alarme' ,sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Derniere_position', label : 'Dernière Position' ,sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'extraction', label : 'Extraction', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'graph', label : 'Graphes', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    ];
                }
                else {
                    fields=[
                        {key :'Nom_du_compteur', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Type_compteur', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Niveau_Batterie', sortable: true,thClass: this.thClass,tdClass: this.tdClass } ,
                        {key :'Compteur_absolu', sortable: true,thClass: this.thClass,tdClass: this.tdClass } ,
                        {key :'Time_use', label :'Temps d\'utilisation', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Derniere_mise_a_jour', label :'Dernière mise à jour', sortKey:'SDate_on_update', sortable: true,thClass: this.thClass,tdClass:this.tdClass  } ,
                        {key :key ,label:label, sortable: true, thClass: this.thClass,tdClass: this.tdClass } ,
                        {key :'status', label : 'Alarme', sortable: true, thClass: this.thClass, tdClass: this.tdClass  } ,
                        {key :'Derniere_position', label : 'Dernière Position', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'extraction', label : 'Extraction', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'graph', label : 'Graphes', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    ];
                }
                return fields;
            },
            items(){
                var items=[];
                var type="" ;
                var system="";
                var Outil_associe_depuis="";
                var batteryWarning=false;
                var update_warning=false;
                for (var sensor of this.sensors){
                    switch (sensor.type) {
                        case 1: type="Compte tour"; break;
                        case 2: type="Horaire à\nrotation PDF"; break;
                        case 3: type="Horaire à\ninclinaison"; break;
                        case 4: type="Contact Sec"; break;
                        case 5: type="Train\nd'impulsion"; break;
                        case 6: type="Horaire à\nvibration"; break;
                        case 7: type="Nb Impulsion"; break;
                        case 8: type="Horaire à\nrotation"; break;
                        case 9: type="Horaire\n9..24Vdc"; break;
                        case 10: type="Virtuel Absolu"; break;
                        case 11: type="Virtuel Relatif"; break;
                        default: type="Non référencé";
                    }
                    if(!sensor.system){
                        system='-';
                        Outil_associe_depuis='';
                    }
                    
                    else {
                        system = sensor.system.name;//+" ("+sensor.system.code+")";
                        Outil_associe_depuis="depuis le "+this.getDate(sensor.system.pivot.created_at);
                    }
                    
                    sensor.latitude = parseFloat(sensor.latitude);
                    sensor.longitude = parseFloat(sensor.longitude);

                    //test des warnings 
                    batteryWarning = false;
                    update_warning = false;
                    if(sensor.hasWarning){
                        if(sensor.warnings.includes(1)){
                            batteryWarning = true;
                        }
                        if(sensor.warnings.includes(2)){
                            update_warning = true;
                        }
                    }

                    items.push({
                        sensor : sensor,
                        Nom_du_compteur : sensor.name,
                        Type_compteur : type,  
                        Niveau_Batterie: sensor.battery,
                        Compteur_absolu : sensor.value_abs,
                        Time_use : this.seconds_To_Hms(sensor.time_use),
                        Derniere_mise_a_jour : this.timeSinceDate(sensor.SDate_on_update),
                        SDate_on_update : sensor.SDate_on_update,
                        Outil_associe :system ,
                        Outil_associe_depuis :Outil_associe_depuis, 
                        Calibration_compteur : sensor.mirror_system,
                        status : sensor.status,
                        Derniere_position : Outil_associe_depuis,
                        BatteryWarning : batteryWarning,
                        LastUpdateWarning : update_warning
                    });
                    type="";
                    system="";
                    Outil_associe_depuis="";
                }

                return items;
            },
            limitedDate(){
                let date = new Date();
                let nowDate = Date.parse(date);
                //console.log(nowDate);
                let limitedDate = nowDate - (24*3600*10000);
                return limitedDate;
            }

        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        mounted() {
            this.$store.dispatch('structure/getStructure');
            this.$store.dispatch('sensors/getSensors');
            this.$store.dispatch('systems/getSystems');
            this.rows = this.sensors.length;
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            },

            formatDate: function(date){
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = '' + d.getFullYear(),
                    hour = '' + d.getHours(),
                    minute ='' + d.getMinutes();
                //console.log("Date_to_format "+d)
                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;
                if (hour.length < 2) 
                    hour = '0' + hour;
                if (minute.length < 2) 
                    minute = '0' + minute;

                return [year, month, day].join('-') + " à " + [hour, minute].join(':');
            },

            timeSinceDate: function(lastUp){

                let date= new Date();
                let nowDate = Date.parse(date);

                var lastDate = Date.parse(lastUp) - date.getTimezoneOffset()*60*1000;//On part déjà d'une date UTC auquel on réapplique les timezone offset
                
                //console.log("NowDate: "+ date + "\t" + nowDate);
               //console.log("LastUp: "+ lastUp + "\t" + lastDate);

                var diff = nowDate - lastDate;
                //console.log(diff);
                if(diff > 0){
                    var diffDate = new Date(diff);
                    diffDate = new Date(diff+diffDate.getTimezoneOffset()*60*1000); //Pour corriger le passage d'utc à heure locale
                    var lastUpdate = "";
                    //console.log(diffDate)

                    if((diffDate.getFullYear() > 1970) || (diffDate.getMonth()>0) || (diffDate.getDate()>1)){

                        if(diffDate.getFullYear() > 1970){
                            lastUpdate = lastUpdate + (diffDate.getFullYear()-1970) + " an(s) ";
                        }
                        if(diffDate.getMonth()>0){
                            lastUpdate = lastUpdate + diffDate.getMonth() + " mois ";
                        }
                        if(diffDate.getDate()>0){
                            if(diffDate.getDate() == 1){
                                lastUpdate = lastUpdate + diffDate.getDate() + " jour ";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getDate() + " jours ";
                            }
                        }
                        return lastUpdate + " (" + this.formatDate(lastDate).substring(0,10) +")"
                    }
                    else if((diffDate.getHours()>0) || (diffDate.getMinutes()>0)){
                        if(diffDate.getHours()>0){
                            if(diffDate.getHours() == 1){
                                lastUpdate = lastUpdate + diffDate.getHours() + " heure ";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getHours() + " heures ";
                            }
                        }
                        if(diffDate.getMinutes()>0){
                            if(diffDate.getMinutes() == 1){
                                lastUpdate = lastUpdate + diffDate.getMinutes() + " minute";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getMinutes() + " minutes";
                            }
                        }
                        return lastUpdate + " (" + this.formatDate(lastDate) +")"
                    }
                }
                else if(lastUp == null){
                    return "Information non disponible"
                }

            },
            seconds_To_Hms(timestamp){

                var hours = Math.floor(timestamp / 3600 );

                var minutes = Math.floor(timestamp / 60) - (hours * 60);

                //var seconds = timestamp % 60;
                
                var formatted=""
                /* // pour afficher jour H:m:s au cas ou on passe 24h 
                if(hours>=24){
                    var days=Math.floor(hours / 24);
                    formatted +=days.toString().padStart(2, '0')+" jour(s) ";
                    hours -= days * 24 ;
                }
                */
                //affichage de type H:m
                //formatted += hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0')+" h";
                //affichage en H.h (un seul chiffre aprèsl la virgule)
                formatted = parseFloat((timestamp/360).toFixed(0))/10 + " h"
                return formatted ;

            },
            getDate(date){
                var d = new Date(date);
                var day = d.getDate(); 
                var m = d.getMonth()+1;
                var y = d.getFullYear();
                var fulldate=y+"-";
                if(m<10) fulldate+="0";
                fulldate+=m+"-";
                if(day<10) fulldate+="0";
                fulldate+=day;
                return fulldate;
            },

            unassign_sensor(sensor) {
                var r = confirm("Voulez vous vraiment supprimer l'affectation ?");
                if (r == true) {
                    let url = api.url + 'sensors/'+ sensor.id + '/unassign/'+ sensor.system.id + '?structure_id=' + this.$store.getters.structure_id;
                    this.axios({url: url, method: 'GET' })
                        .then(resp => {
                            if(resp.status < 400){
                                this.$store.dispatch('sensors/getSensors');
                            }
                        })
                        .catch(err => {
                            //console.log(err);
                        });
                }
            },

            assign_modal(sensor) {
                this.selected_system = null;
                this.selected_sensor = sensor;
              //  console.log(this.free_systems);
              //  console.log(this.systems);

                let url = api.url + 'systems/freeSystems?structure_id=' + this.$store.getters.structure_id;
             //   console.log(url);

                this.axios({url: url, method: 'GET' })
                    .then(resp => {
               //         console.log(resp);
                        if(resp.status <400){
                            this.free_systems = resp.data;
                        }
                    })
                    .catch(err => {
                        //console.log(err);
                    });

                //console.log(this.free_systems);
                
                this.$refs.assign_modal.show()
                
            },
            assign_cancel() {
                this.$refs.assign_modal.hide()
            },
            assign_submit() {

                let url = api.url + 'sensors/'+ this.selected_sensor.id + '/assign/' + this.selected_system.id + '?structure_id=' + this.$store.getters.structure_id;

                this.axios({url: url, method: 'GET' })
                    .then(resp => {
                        if(resp.status <400){
                            this.$store.dispatch('sensors/getSensors');
                            this.$refs.assign_modal.hide();
                            //this.$router.push("/sensors/index");
                            this.$router.push("/sensors/index").catch(()=>{});

                            //console.log("ici : "+ resp); 
                            /*
                            if(resp){
                                var r = alert(" Matériel non disponible ?");
                                if (r == true) {
                                    
                                }
                            } */
                        }
                    })
                    .catch(err => {
                        //console.log(err);
                    });
            },

          /*  checkAlarm: function(){
                let date = new Date();
                let nowDate = Date.parse(date);
                //console.log(nowDate);
                let limitedDate = nowDate - (24*3600*10000); // date limite avant 10 jours
                console.log("Limit " + new Date(limitedDate));

                for(var sensor of this.sensors){
                    
                    //console.log(sensor.SDate_on_update)

                    if(Date.parse(sensor.SDate_on_update) <= limitedDate){
                        var lastUpLabel = document.getElementById(sensor.name).children.namedItem("update")
                        lastUpLabel.innerHTML = '<p class="mrg-top-15" style="color:red">'+lastUpLabel.innerText+ '</p>'
                        //console.log (resp_update)
                        
                    }

                    if(sensor.battery <=3.3){
                        var battLabel = document.getElementById(sensor.name).children.namedItem("batt")
                        battLabel.innerHTML = '<p class="mrg-top-15" style="color:red">'+battLabel.innerText+ '</p>'
                        //console.log(resp_bat);
                    }

                }
                
            },*/
            open_calibrate_modal(system) {

                //Passer le système selectionné à l'enfant
                this.mirror_system = system;
                this.$refs.calibration_popup.show()
            },
            map_modal_open(sensor) {

                this.selected_sensor = sensor;
                //Passer le système selectionné à l'enfant
                this.$refs.map_popup.show()
            },
            
            open_extraction_sensor(sensor){
                //Passer le système selectionné à l'enfant
                this.selected_sensor = sensor;
                this.$refs.extraction_popup_sensor.show();
            },
            close_extraction_sensor() {
                this.$refs.extraction_popup_sensor.hide();
                this.$store.dispatch('sensors/getSensors').then(() => {
                    this.sortDirection = '';
                    this.sortBy ='';
                });
            },
            
            graph_sensor_modal_open(sensor){
                this.selected_sensor = sensor;
                //Passer le système selectionné à l'enfant
                this.$refs.graph_popup_sensor.show()
            },
            close_graph_sensor_modal() {
                this.$refs.graph_popup_sensor.hide();
            },

            change_alarm(sensor) {
                //TODO poster vers l'api
                if(sensor.status & 0x01){
                    var r = confirm("Voulez vous vraiment désactiver les alarmes ?");
                    if (r == true) {
                        sensor.status &= 0xF0;
                        let url = api.url + 'sensors/'+ sensor.id + '?structure_id=' + this.$store.getters.structure_id + '&status=' + sensor.status;
                        this.axios({url: url, method: 'PUT' })
                            .then(resp => {
                                if(resp.status < 400){
                                    this.$store.dispatch('sensors/getSensors');
                                }
                                else {
                                    //
                                }
                            })
                            .catch(err => {
                                //console.log(err);
                            });
                    }
                }
                else{
                    sensor.status +=1;
                    let url = api.url + 'sensors/'+ sensor.id + '?structure_id=' + this.$store.getters.structure_id + '&status=' + sensor.status;
                    this.axios({url: url, method: 'PUT' })
                        .then(resp => {
                            if(resp.status < 400){
                                this.$store.dispatch('sensors/getSensors');
                            }
                        })
                        .catch(err => {
                            //console.log(err);
                        });
                }
            },

            close_calibrate_modal() {
                this.$refs.calibration_popup.hide();
                this.$store.dispatch('systems/getSystems');
                this.$store.dispatch('sensors/getSensors');
            },
            close_map_modal() {
                this.$refs.map_popup.hide();
            },
            onFiltered(filteredItems) {
                this.rows = filteredItems.length
            },
        }

    }
</script>

<style>

.asc:after{
    content: "\25B2"
}

.desc:after{
    content: "\25BC"
}
.BTable{
    max-height: 700px;
}

</style>